/* */ 
(function(Buffer) {
  'use strict';
  var ono = require('ono'),
      debug = require('./util/debug'),
      url = require('./util/url'),
      plugins = require('./util/plugins'),
      Promise = require('./util/promise');
  module.exports = parse;
  function parse(path, $refs, options) {
    try {
      path = url.stripHash(path);
      var $ref = $refs._add(path);
      var file = {
        url: path,
        extension: url.getExtension(path)
      };
      return readFile(file, options).then(function(resolver) {
        $ref.pathType = resolver.plugin.name;
        file.data = resolver.result;
        return parseFile(file, options);
      }).then(function(parser) {
        $ref.value = parser.result;
        return parser.result;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }
  function readFile(file, options) {
    return new Promise(function(resolve, reject) {
      debug('Reading %s', file.url);
      var resolvers = plugins.all(options.resolve);
      resolvers = plugins.filter(resolvers, 'canRead', file);
      plugins.sort(resolvers);
      plugins.run(resolvers, 'read', file).then(resolve, onError);
      function onError(err) {
        if (err && !(err instanceof SyntaxError)) {
          reject(err);
        } else {
          reject(ono.syntax('Unable to resolve $ref pointer "%s"', file.url));
        }
      }
    });
  }
  function parseFile(file, options) {
    return new Promise(function(resolve, reject) {
      debug('Parsing %s', file.url);
      var allParsers = plugins.all(options.parse);
      var filteredParsers = plugins.filter(allParsers, 'canParse', file);
      var parsers = filteredParsers.length > 0 ? filteredParsers : allParsers;
      plugins.sort(parsers);
      plugins.run(parsers, 'parse', file).then(onParsed, onError);
      function onParsed(parser) {
        if (!parser.plugin.allowEmpty && isEmpty(parser.result)) {
          reject(ono.syntax('Error parsing "%s" as %s. \nParsed value is empty', file.url, parser.plugin.name));
        } else {
          resolve(parser);
        }
      }
      function onError(err) {
        if (err) {
          err = err instanceof Error ? err : new Error(err);
          reject(ono.syntax(err, 'Error parsing %s', file.url));
        } else {
          reject(ono.syntax('Unable to parse %s', file.url));
        }
      }
    });
  }
  function isEmpty(value) {
    return value === undefined || (typeof value === 'object' && Object.keys(value).length === 0) || (typeof value === 'string' && value.trim().length === 0) || (Buffer.isBuffer(value) && value.length === 0);
  }
})(require('buffer').Buffer);
